<template>
	<div>
		<v-btn @click="openMedia = !openMedia">
			<v-icon v-if="!openMedia">
				fa-plus
			</v-icon>
			<v-icon v-if="openMedia">
				fa-minus
			</v-icon>
			הוספת מדיה לשאלה
		</v-btn>
		<div v-if="openMedia">
			<media-type-select v-model="before_question_media" />
			<media-gallery
				v-if="before_question_media=='img'"
				@selected="selectedImage"
			/>
			<v-img
				v-if="before_question_media=='img'"
				:src="before_question"
				max-width="75"
			/>
			<smart-input
				v-if="before_question_media==='video'"
				v-model="before_question"
				label="קישור למדיה"
				prepend-icon="fab fa-youtube"
			/>
			<smart-input
				v-model="before_question_text"
				label="כיתוב נוסף בהופעת המדיה"
			/>
		</div>
	</div>
</template>

<script>
import MediaTypeSelect from "../questions/MediaTypeSelect";
import MediaGallery from "../../../../../../src/packages/gallery/MediaGallery";

export default {
	name: "AddMedia",
	components: { MediaGallery, MediaTypeSelect },
	props: ["beforeQuestionMedia", "beforeQuestion", "beforeQuestionText", "inputErrors", "isNew"],
	data () {
		return {
			rules: [
				value => !value || value.size < 500000 || "גודל התמונה צריך להית עד 500k",
			],
			openMedia: this.before_question && this.before_question !== "",
			before_question_text: "",
			before_question: null,
			before_question_media: null,
		};
	},
	watch: {
		before_question_media (newType) {
			this.$emit("before_question_media", newType);
		},
		before_question (newValue) {
			this.$emit("before_question", newValue);
		},
		before_question_text (newValue) {
			this.$emit("before_question_text", newValue);
		},
	},
	methods: {
		selectedImage (img) {
			this.$emit("updatedQuestionImage", img);
		},
	},
};
</script>

<style scoped>
	.image-preview {
		max-width: 75px;
	}
</style>
